import {ImageLoader} from 'next/image';

const shopifyImageLoader: ImageLoader = ({src, width}) => {
    if (src.startsWith('https://cdn.shopify.com')) {
        return `${src}&width=${width}`
    } else return src;
};
export {shopifyImageLoader}

